import {ENTITY_MAP, ROLE_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import {
  isFemaUser,
  filterExcludedRolesFromPermissions,
  getUserEntitiesForEntityType,
} from 'common/utils';
import PermissionsUtility from 'go/security/permissionsUtility';
import {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import REST from 'go/requests/rest';
import React from 'react';
import _ from 'lodash';
import FemaWorkCard from './FemaWorkCard';
import programRequests from 'go/requests/rest/entity/programRequests';
import {isSPGA} from 'go/security/permissions';
import {isSMA} from 'go/security/permissions';
import {
  PROGRAM_STATUS_CODES,
  DRAFT_FO_STATUS_CODES,
} from 'common/requestDetails/constants';
import {EXCLUDED_ROLES} from 'app-ui-componentlibrary/dist/common/constants';

export const FemaActions = (props) => {
  const [fundingOpportunities, setFundingOpportunities] = useState([]);
  const [foWithSignedAwardsSubAwards, setFoWithSignedAwardsSubAwards] = useState([]);
  const [assignedOpenTasks, setAssignedOpenTasks] = useState([]);
  const [userSavedForLater, setUserSavedForLater] = useState([]);
  const [loading, setLoading] = useState(true);
  const addFOCommitmentToggledOn = _.includes(
    _.get(props, 'toggles', []),
    'addFOCommitment'
  );
  const isSMAUserorSPGAUser = isSMA(props.permissions) || isSPGA(props.permissions);

  useEffect(() => {
    retrieveFosAndPrograms();
    retrieveAssignedOpenTasks();
    retrieveUserSavedForLater();
  }, []);

  const {token, permissions} = props;

  const fetchBody = {
    candidateGroups: filterExcludedRolesFromPermissions(permissions, EXCLUDED_ROLES),
    assigned: true,
    assignee: token.userId,
    includeAssignedTasks: true,
    processVariables: [],
    sorting: [],
  };

  const retrieveAssignedOpenTasks = async () => {
    REST.workflow
      .getTasksWithVariables(
        token,
        fetchBody,
        [
          'fundingOpportunityName',
          'organizationName',
          'organizationId',
          'subOrganizationName',
          'subOrgId',
          'grantId',
          'subGrantId',
          'fundingOpportunityId',
          'priorityDisplay',
        ],
        1500,
        0
      )
      .then(REST.handler.handleResponse)
      .then((results) => {
        setAssignedOpenTasks(results);
      })
      .catch((error) => {
        console.error('error');
      });
  };

  const retrieveUserSavedForLater = async () => {
    REST.dynamicData
      .getSavedForUser(token)
      .then(REST.handler.handleResponse)
      .then((results) => {
        setUserSavedForLater(results);
      })
      .catch((error) => {
        console.error('error');
      });
  };

  const retrieveFosAndPrograms = async () => {
    const {token, permissions} = props;
    const programIds = [];
    const foIds = [];

    const isSMAUser = permissions.some(
      (permission) => permission.split(':')[2] === ROLE_MAP.SMA.code
    );
    const isSMUUser = permissions.some(
      (permission) => permission.split(':')[2] === ROLE_MAP.SMU.code
    );
    const isSMUorSMAUser = isSMAUser || isSMUUser;

    if (isSMUorSMAUser) {
      const programs = await (
        await programRequests.getProgramsByStatus(PROGRAM_STATUS_CODES.APPROVED)
      ).json();
      programs.map((program) => programIds.push(program.programId));
    } else {
      permissions.sort().forEach((permission) => {
        const [entityTypeId, entityId, roleId] = permission.split(':');

        if (entityTypeId == ENTITY_MAP.PROGRAM.code) {
          if (!programIds.includes(parseInt(entityId))) {
            programIds.push(parseInt(entityId));
          }
        } else if (entityTypeId == ENTITY_MAP.FUNDING_OPPORTUNITY.code) {
          if (!foIds.includes(parseInt(entityId))) {
            foIds.push(parseInt(entityId));
          }
        }
      });
    }

    try {
      const foRequests = _.map(programIds, (programId) =>
        REST.fundingOpportunity.getFundingOpportunitiesForProgram(token, programId)
      );

      const foRespJson = await Promise.all(foRequests).then((foResponses) =>
        Promise.all(_.map(foResponses, (resp) => resp.json()))
      );

      const foDraftRequests = _.map(programIds, (programId) =>
        REST.fundingOpportunity.getDraftFundingOpportunitiesForProgramByStatus(
          token,
          programId,
          DRAFT_FO_STATUS_CODES.DRAFT
        )
      );

      const signedFOsRequest = await REST.search
        .getFOsWithSignedAwardsSubawards(token)
        .then(REST.handler.handleResponse)
        .then((res) => {
          let signedFOs = [];
          _.map(res.items, (fo) => {
            signedFOs.push(fo.fundingOpportunityId);
          });
          setFoWithSignedAwardsSubAwards(signedFOs);
        });

      const foDraftRespJson = await Promise.all(foDraftRequests).then((foResponses) =>
        Promise.all(_.map(foResponses, (resp) => resp.json()))
      );

      const fundingOpportunities = _.chain(foRespJson)
        .map('payload')
        .map((resp) => JSON.parse(resp))
        .map('fundingOpportunities')
        .flatten()
        .value();

      const draftFundingOpportunities = _.chain(foDraftRespJson)
        .map('payload')
        .map((resp) => JSON.parse(resp))
        .map('fundingOpportunities')
        .flatten()
        .value();

      // retrieve remaining FOs from FO-level permissions
      _.forEach(fundingOpportunities, (fo) => {
        const {fundingOpportunityId} = fo;
        _.remove(foIds, (foId) => foId == fundingOpportunityId);
      });

      const remainingFoRequests = _.map(foIds, (foId) =>
        REST.fundingOpportunity
          .getFundingOpportunity(token, foId)
          .then(REST.handler.handleResponse)
      );

      const remainingFos = await Promise.all(remainingFoRequests);

      _.forEach(remainingFos, (fo) => {
        programIds.push(fo.programId);
      });

      // retrieve programs for program names
      const programRequests = _.map(programIds, (programId) =>
        REST.program.getProgramById(token, programId).then(REST.handler.handleResponse)
      );

      const programs = await Promise.all(programRequests);
      let allFos;
      if (isSMUUser) {
        allFos = addFOCommitmentToggledOn ? fundingOpportunities : [];
      } else {
        const fos = _.union(fundingOpportunities, remainingFos);
        _.forEach(draftFundingOpportunities, (draft) => {
          _.remove(fos, (fo) => fo.fundingOpportunityId === draft.fundingOpportunityId);
        });
        allFos = _.union(draftFundingOpportunities, fos);
      }
      allFos = _.map(allFos, (fo) => {
        const program = _.find(programs, (program) => program.programId == fo.programId);

        return {
          ...fo,
          programName: program.programName,
          fundingOpportunityName: _.get(
            fo,
            'fundingOpportunityName',
            _.get(fo, 'payload.foName', '')
          ),
        };
      });

      if (isSMAUserorSPGAUser) {
        setFundingOpportunities(_.sortBy(allFos, (fo) => fo.fundingOpportunityName));
      } else {
        const allPublishedFos = _.filter(allFos, function (fo) {
          return !(
            _.get(fo, 'status', '') === 'draft' &&
            _.get(fo, 'fundingOpportunityId') == null
          );
        });
        setFundingOpportunities(
          _.sortBy(allPublishedFos, (fo) => fo.fundingOpportunityName)
        );
      }
      setLoading(false);
    } catch (e) {
      console.error('Error retrieving funding opportunities or programs: ', e);
    }
  };

  return (
    <React.Fragment>
      {isFemaUser(props.permissions) && (
        <FemaWorkCard
          fundingOpportunities={fundingOpportunities}
          retrieveUserSavedForLater={retrieveUserSavedForLater}
          loading={loading}
          signedFOs={foWithSignedAwardsSubAwards}
          assignedOpenTasks={assignedOpenTasks}
          userSavedForLater={userSavedForLater}
          assignee={token.userId}
          isSMAUserorSPGAUser={isSMAUserorSPGAUser}
        />
      )}
    </React.Fragment>
  );
};

export const mapStateToProps = (state) => {
  return {
    toggles: state.toggles.toggles,
  };
};

export default connect(mapStateToProps, null)(FemaActions);
